// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__3y2-c","subheader":"ReorderModal_subheader__1in5U","listWrap":"ReorderModal_listWrap__yD0jl"};